/** E.164 US numbers as stored in the app (e.g. +14589940242). */
const e164UsRegex = /^\+1\d{10}$/;

/**
 * Formats a US phone number for display, e.g. `(458) 994-0242`.
 * Accepts E.164 `+1`…, 10-digit national, or 11 digits with leading country code 1.
 * Returns the original string when the value is not a recognizable US number.
 * Null/undefined yields an empty string (API / DTO fields may omit numbers).
 */
export const formatPhoneNumber = (
  value: string | null | undefined
): string => {
  if (value == null) {
    return '';
  }
  const raw = typeof value === 'string' ? value : String(value);
  const trimmed = raw.trim();
  if (!trimmed) {
    return raw;
  }

  if (e164UsRegex.test(trimmed)) {
    const areaCode = trimmed.substring(2, 5);
    const centerThree = trimmed.substring(5, 8);
    const lastFour = trimmed.substring(8, 12);
    return `(${areaCode}) ${centerThree}-${lastFour}`;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    const d = digits.slice(1);
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }

  return raw;
};
